import React from "react";
import { CircularsContainer } from "./style";
import { Container } from "react-bootstrap";
const Circulars = () => {
  return (
    <CircularsContainer>
      <Container>
        <div className="items">
          <a
            href="./pdf/1.pdf"
            target="_blank"
            className="item"
          >
              بخشنامه پیش فروش عادی خودروی اکلیپس کراس اسفند - 1403
          </a>
            <a
            href="./pdf/2.pdf"
            target="_blank"
            className="item"
          >
                بخشنامه فروش فوق العاده اوتلندر - اسفند 1403 H-line-4WD
          </a>
            <a
            href="./pdf/p-line1403-12.pdf"
            target="_blank"
            className="item"
          >
                بخشنامه فروش فوق العاده  اوتلندر - اسفند 1403 P-line
          </a>
        </div>
      </Container>
    </CircularsContainer>
  );
};
export default Circulars;
